<div class="bearbeiten-dialog">
    <h2 mat-dialog-title>
        <mat-icon>edit</mat-icon>
        Kontakt bearbeiten
    </h2>

    <mat-dialog-content>
        <div class="kontakt-info-header">
            <h3>{{ data.kontakt.bezeichnung_final }}</h3>
            <p *ngIf="data.kontakt.zusatz_final" class="zusatz">{{ data.kontakt.zusatz_final }}</p>
            <p class="vvvo">VVVO: {{ data.kontakt.vvvo }}</p>
        </div>

        <form [formGroup]="bearbeitenForm" class="bearbeiten-form">
            <div class="form-row">
                <mat-checkbox formControlName="favorit" color="accent">
                    <mat-icon>star</mat-icon>
                    Als Favorit markieren
                </mat-checkbox>
            </div>

            <div class="form-row">
                <mat-checkbox formControlName="ist_kunde" color="accent" [disabled]="true">
                    <mat-icon>person</mat-icon>
                    Ist Kunde des Systems (automatisch gesetzt)
                </mat-checkbox>
            </div>

            <div class="form-row" *ngIf="isReadOnlyKontakt">
                <p class="readonly-hint">Dieser Kontakt wurde von einem anderen Benutzer angelegt und ist schreibgeschützt.</p>
            </div>

            <!-- Betriebsdaten -->
            <div class="betriebsdaten-section">
                <h4 class="section-title">
                    <mat-icon>business</mat-icon>
                    Betriebsdaten
                </h4>
                <p class="readonly-hint" *ngIf="isVvvoPlaceholderBetrieb && !isReadOnlyKontakt">
                    Dieser Betrieb wurde beim Pass-Scan nur mit der VVVO-Nummer angelegt. Name und Kontaktdaten können hier korrigiert werden.
                </p>
                <p
                    class="readonly-hint"
                    *ngIf="bearbeitenForm.get('ist_kunde')?.value && !isVvvoPlaceholderBetrieb"
                >
                    Für Systemkunden sind diese Felder schreibgeschützt.
                </p>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Betriebsname</mat-label>
                        <input matInput formControlName="bezeichnung" placeholder="Betriebsname eingeben" />
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Zusatz</mat-label>
                        <input matInput formControlName="zusatz" placeholder="Zusatz eingeben" />
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Straße</mat-label>
                        <input matInput formControlName="strasse" placeholder="Straße eingeben" />
                    </mat-form-field>
                </div>

                <div class="form-row two-columns">
                    <mat-form-field appearance="outline">
                        <mat-label>PLZ</mat-label>
                        <input matInput formControlName="plz" placeholder="PLZ eingeben" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Ort</mat-label>
                        <input matInput formControlName="ort" placeholder="Ort eingeben" />
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Ortsteil</mat-label>
                        <input matInput formControlName="ortsteil" placeholder="Ortsteil eingeben" />
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>E-Mail</mat-label>
                        <input matInput formControlName="email" type="email" placeholder="E-Mail eingeben" />
                    </mat-form-field>
                </div>

                <div class="form-row two-columns">
                    <mat-form-field appearance="outline">
                        <mat-label>Telefon 1</mat-label>
                        <input matInput formControlName="telefon_1" placeholder="Telefon eingeben" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Telefon 2</mat-label>
                        <input matInput formControlName="telefon_2" placeholder="Telefon eingeben" />
                    </mat-form-field>
                </div>

                <div class="form-row two-columns">
                    <mat-form-field appearance="outline">
                        <mat-label>Mobil 1</mat-label>
                        <input matInput formControlName="mobil_1" placeholder="Mobil eingeben" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Mobil 2</mat-label>
                        <input matInput formControlName="mobil_2" placeholder="Mobil eingeben" />
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions-row">
        <button
            mat-raised-button
            color="accent"
            (click)="speichern()"
            [disabled]="ladeSpeichern || !bearbeitenForm.valid || isReadOnlyKontakt"
        >
            <mat-spinner *ngIf="ladeSpeichern" diameter="16"></mat-spinner>
            <mat-icon *ngIf="!ladeSpeichern">save</mat-icon>
            {{ ladeSpeichern ? "Speichere..." : "Speichern" }}
        </button>
        <button mat-button (click)="abbrechen()" [disabled]="ladeSpeichern"> Abbrechen </button>
    </mat-dialog-actions>
</div>
